import { useNavigate } from "react-router-dom";
import { ChevronDown, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useMe } from "@/components/app/MeContext";

export const LM_TYPES = [["LMP", "Packaging order"], ["LMR", "Refrigeration order"], ["LMPP", "Projection order (PO pending)"]];
export const FAMILY = {
  lm: { title: "LM Register", sub: "Regular one-time orders: LMP, LMR and LMPP (projection). Click a row to open the LM.", prefixes: ["LMP", "LMR", "LMPP"] },
  lms: { title: "LMS Register", sub: "Service actions against an Asset Group / asset / contract: visits, breakdowns, PM, ad hoc work, spare sales.", prefixes: ["LMS"] },
};

// Add LM ▼ (LMP / LMR / LMPP) · Add LMS · Add LMO - shown only to roles that can create LMs
export function CreateButtons() {
  const { can } = useMe();
  const navigate = useNavigate();
  if (!can("orders.create")) return null;
  const go = (t) => navigate(`/orders/new?type=${t}`);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild><Button data-testid="add-lm-dropdown"><Plus className="h-4 w-4 mr-1" />Add LM<ChevronDown className="h-4 w-4 ml-1" /></Button></DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {LM_TYPES.map(([p, d]) => <DropdownMenuItem key={p} onClick={() => go(p)} data-testid={`add-${p.toLowerCase()}`}><b className="font-mono mr-2">Add {p}</b><span className="text-xs text-slate-500">{d}</span></DropdownMenuItem>)}
        </DropdownMenuContent>
      </DropdownMenu>
      <Button variant="outline" onClick={() => go("LMS")} data-testid="add-lms-btn"><Plus className="h-4 w-4 mr-1" />Add LMS</Button>
      <Button variant="outline" onClick={() => go("LMO")} data-testid="add-lmo-btn"><Plus className="h-4 w-4 mr-1" />Add LMO</Button>
    </>
  );
}
